import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Backdrop, Fade, Button, FormControlLabel, Checkbox } from '@mui/material';
import { Text, Title } from 'shared/components';
import IntroItem from '../IntroItem';
import { makeStyles } from '@mui/styles';
import PageviewIcon from '@mui/icons-material/Pageview';
import AddIcon from '@mui/icons-material/Add';
import NotificationsIcon from '@mui/icons-material/Notifications';
import FeedbackIcon from '@mui/icons-material/Feedback';
import CloseIcon from '@mui/icons-material/Close';

const OPTIONS = [
  {
    title: 'View Just Your Donations',
    description: 'Show only donations and reports for which you are the assigned Portfolio Manager',
    icon: <PageviewIcon style={{ fontSize: 50 }}/>
  },
  {
    title: 'Add New Donations',
    description: 'Create a new donation to one or more nonprofits',
    icon: <AddIcon style={{ fontSize: 50 }}/>
  },
  {
    title: 'Notify Nonprofits of Donations',
    description: 'Notify nonprofits of donations and invite them to complete social impact reports',
    icon: <NotificationsIcon style={{ fontSize: 50 }}/>
  },
  {
    title: 'Provide Feedback on Reports',
    description: 'View reports awaiting your feedback and provide guidance on how to improve the quality of the reported data before ' +
      'the report is finalized',
    icon: <FeedbackIcon style={{ fontSize: 50 }}/>
  },
];

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    width: '60%',
    heigh: 'auto',
    padding: theme.spacing(2, 4, 3),
    textAlign: 'center',
  },
  item: {
    width: 'calc(25% - 5px)',
    float: 'left',
    marginRight: '5px',
  },
  optionsContainer: {
    width: '100%',
    marginTop: '20px',
    marginBottom: '20px',
  },
  checkbox: {
    position: 'absolute',
    right: 0
  },
  closeIcon: {
    position: 'absolute',
    top: 0,
    right: 0
  },
}));

const HomeIntroModal = ({ open, onClose, onPressItem }) => {
  const classes = useStyles();
  const [ hideIsChecked, setHideIsChecked ] = useState(false);

  const handleClose = () => {
    onClose(hideIsChecked);
  };

  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <div className={classes.paper}>
          <CloseIcon onClick={handleClose} className={classes.closeIcon}/>
          <Title centered>Welcome to the new Donor Portal</Title>
          <Text centered>Would you like to:</Text>
          <div className={classes.optionsContainer}>
            { OPTIONS.map((option, index) => (
              <div className={classes.item} key={option.id}>
                <IntroItem
                  {...option}
                  onClick={() => onPressItem(index, hideIsChecked)}
                />
              </div>
            ))}
          </div>
          <Button
            color="primary"
            onClick={handleClose}
          >
            Close 
          </Button>
          <FormControlLabel
            className={classes.checkbox}
            control={<Checkbox
              checked={hideIsChecked}
              onChange={() => setHideIsChecked(!hideIsChecked)}
            />}
            label="Hide this popup on next login"
          />
        </div>
      </Fade>
    </Modal>
  );
};

HomeIntroModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onPressItem: PropTypes.func,
};

export default HomeIntroModal;
